export default __webpack_public_path__ + "static/media/b-sm4.49313860.png";